// Configure Offset APIs
require("./offset.config.js");

// Include Stylesheet
require("../../css/src/stylesheet.scss");

// Include Figure Base Resources
require("FigureBaseResources");

// Custom Site Stuff
require("./theme.js");

// Load via script tag:
// require('script-loader!./scroller.js')

// Expose a variable from a library:
// const scroller = require('expose-loader?scroller!./scroller.js')

// Offset Consent
const { ConsentManager, ConsentUI } = require("offset-consent");
(new ConsentUI(new ConsentManager(window.OFFSET.consent))).mount();
